// src/components/CategoriesCarousel.js
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { db } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const fadeIn = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } }
};

const CategoriesCarousel = ({ onSelectCategory }) => {
      const [categories, setCategories] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "categorias"), (snap) => {
      setCategories(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsub();
  }, []);

  return (
    <motion.section
      className="container mx-auto py-12"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeIn}
    >
      <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-center">Categorías</h2>
      <Swiper
        modules={[Navigation, Autoplay]}
        slidesPerView={1}
        spaceBetween={18}
        navigation
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        breakpoints={{
          640: { slidesPerView: 2 },
          900: { slidesPerView: 3 },
          1200: { slidesPerView: 4 }
        }}
        loop
        className="pb-4"
      >
        {categories.map((cat) => (
          <SwiperSlide key={cat.id}>
            <motion.div
              className="rounded-2xl overflow-hidden shadow-lg group cursor-pointer border bg-white hover:shadow-2xl transition-all"
              whileHover={{ scale: 1.045 }}
 onClick={() => onSelectCategory(cat.name)}            >
              <img
                src={cat.image || "https://via.placeholder.com/400x200?text=Sin+imagen"}
                alt={cat.name}
                className="w-full h-40 object-cover"
              />
              <div className="p-4 bg-gradient-to-r from-blue-100 to-sky-200 text-center">
                <div className="font-bold text-lg text-blue-900">{cat.name}</div>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.section>
  );
};

export default CategoriesCarousel;
